export default function formatPriceEuros(
  price: number,
  locale: 'en' | 'de' | undefined,
) {
  return `${price.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`
}
